import { useState, useCallback } from 'react';

interface BrandLogoProps {
  name: string;
  localSrc?: string; // e.g. /assets/logos/compliance/gdpr.svg
  externalSrc?: string; // fallback URL
  className?: string;
  alt?: string;
  height?: number;
}

const BrandLogo = ({ name, localSrc, externalSrc, className = "max-h-16 w-auto object-contain", alt, height = 64 }: BrandLogoProps) => {
  const [src, setSrc] = useState<string | null>(localSrc || externalSrc || null);

  const handleError = useCallback(() => {
    if (src && localSrc && src === localSrc && externalSrc) {
      setSrc(externalSrc);
    } else {
      setSrc(null);
    }
  }, [src, localSrc, externalSrc]);

  if (!src) {
    return (
      <div className="inline-flex items-center justify-center px-6 py-4 rounded-2xl border-2 border-primary/30 bg-gradient-to-br from-background/40 to-background/60 shadow-inner">
        <span className="text-2xl font-extrabold tracking-wide">{name}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || `${name} logo`}
      className={className}
      height={height}
      loading="lazy"
      decoding="async"
      onError={handleError}
    />
  );
};

export default BrandLogo;


